export enum ReportType {
    LastMonth = 'last-month',
    PenultimateMonth = 'penultimate-month',
    LastYear = 'last-year',
    Month = 'month',
    Year = 'year',
    Custom = 'custom',
}
